import React from 'react';
import { Link } from 'react-router-dom';
import { FaTelegram, FaInstagram, FaVk, FaFacebook, FaTwitter, FaDiscord, FaEnvelope } from 'react-icons/fa';
import Logo from '../Logo'; // Importer le logo
import { BBT_CONFIG } from '../../config/bbt'; // Importer la config pour les liens
import NewsletterForm from '../common/NewsletterForm';

const Footer = () => {
  return (
    <footer className="bg-gray-100 dark:bg-slate-900 border-t border-gray-200 dark:border-slate-800">
      {/* Section Newsletter */}
      <div className="bg-gradient-to-r from-primary/10 via-slate-900 to-secondary/10 border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-center md:text-left">
              <h3 className="text-xl font-bold text-white flex items-center gap-2 justify-center md:justify-start">
                <FaEnvelope className="text-primary" />
                Restez informé
              </h3>
              <p className="text-slate-400 text-sm mt-1">
                Recevez nos actualités et offres exclusives (1 email/mois max)
              </p>
            </div>
            <div className="w-full md:w-auto md:min-w-[400px]">
              <NewsletterForm variant="compact" source="footer" />
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-8">
          
          {/* Colonne Baobab Exchange */}
          <div className="col-span-2 md:col-span-1">
             <div className="flex items-center mb-4">
              <Logo size="small" />
              <span className="ml-2 text-xl font-bold text-gray-800 dark:text-white">Baobab Exchange</span>
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Plateforme d'échange de devises et crypto. Transferts internationaux rapides et sécurisés.
            </p>
          </div>

          {/* Colonne Produits */}
          <div>
            <h3 className="text-gray-800 dark:text-white font-bold mb-4">Produits</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/transfer-money" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Transfert d'argent</Link></li>
              <li><Link to="/wallet" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Portefeuille</Link></li>
              <li><Link to="/affiliation" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Affiliation</Link></li>
            </ul>
          </div>

          {/* NOUVELLE Colonne Écosystème BBT */}
          <div>
            <h3 className="text-gray-800 dark:text-white font-bold mb-4">Écosystème BBT</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/bbt" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Page du Token</Link></li>
              <li><a href={BBT_CONFIG.urls.pancakeSwap} target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Acheter sur PancakeSwap</a></li>
              <li><a href={BBT_CONFIG.urls.bscScan} target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Contrat (BscScan)</a></li>
              <li><a href={BBT_CONFIG.urls.dexTools} target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Graphique (DexTools)</a></li>
            </ul>
          </div>
          
          {/* Colonne Ressources */}
          <div>
            <h3 className="text-gray-800 dark:text-white font-bold mb-4">Ressources</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://baobabexchange.com/whitepaper.pdf" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Whitepaper</a></li>
              <li><Link to="/faq" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">FAQ</Link></li>
              <li><Link to="/support" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Support</Link></li>
              <li><Link to="/blog" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Colonne Légal */}
          <div>
            <h3 className="text-gray-800 dark:text-white font-bold mb-4">Légal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Conditions d'utilisation</Link></li>
              <li><Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Confidentialité</Link></li>
              <li><Link to="/aml-kyc" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Politique AML/KYC</Link></li>
              <li><Link to="/cookies" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors">Politique de cookies</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 dark:border-slate-800 my-6"></div>

        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Baobab Exchange. Tous droits réservés.
          </p>
          <div className="flex items-center space-x-4">
            <a href="https://twitter.com/baobabexchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaTwitter size={20} /></a>
            <a href="https://t.me/baobabexchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaTelegram size={20} /></a>
            <a href="https://discord.gg/baobabexchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaDiscord size={20} /></a>
            <a href="https://instagram.com/baobab_exchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaInstagram size={20} /></a>
            <a href="https://vk.com/baobabexchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaVk size={20} /></a>
            <a href="https://facebook.com/baobabexchange" target="_blank" rel="noopener noreferrer" className="text-gray-600 dark:text-gray-400 hover:text-indigo-600 dark:hover:text-[#00A3E0] transition-colors"><FaFacebook size={20} /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
